import { render, staticRenderFns } from "./verify-address.vue?vue&type=template&id=c8e5ef42&scoped=true&"
import script from "./verify-address.vue?vue&type=script&lang=tsx&"
export * from "./verify-address.vue?vue&type=script&lang=tsx&"
import style0 from "./verify-address.vue?vue&type=style&index=0&id=c8e5ef42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e5ef42",
  null
  
)

export default component.exports